import { makeVar } from '@apollo/client'
import parser from 'accept-language-parser'

import { LocaleText } from '@web/gql/graphql'
import { extractErrorMessage, neloLogger } from '@web/libs/utils'
import { Nullable } from '@web/types'

export const SUPPORT_LANGUAGES = ['ko', 'en'] as const

export const DEFAULT_LANGUAGE = SUPPORT_LANGUAGES[0]

export const langVar = makeVar<(typeof SUPPORT_LANGUAGES)[number]>(DEFAULT_LANGUAGE)

export const parseLanguage = (acceptLanguage: string) => {
  const language = parser.pick(Array.from(SUPPORT_LANGUAGES), acceptLanguage, { loose: true })

  if (!language) {
    neloLogger('warn', '지원하지 않는 언어입니다', {
      acceptLanguage,
      SUPPORT_LANGUAGES,
    })

    return DEFAULT_LANGUAGE
  }

  return language
}

export const setLanguage = (acceptLanguage?: Nullable<string>) => {
  try {
    if (!acceptLanguage) return langVar(DEFAULT_LANGUAGE)

    const lang = parseLanguage(acceptLanguage)

    return langVar(SUPPORT_LANGUAGES.find(supportLang => lang.includes(supportLang)) ?? DEFAULT_LANGUAGE)
  } catch (error) {
    neloLogger('warn', `[setLanguage] ${extractErrorMessage(error)}`)
    return DEFAULT_LANGUAGE
  }
}

export type SERVER_SUPPORT_LANGUAGES = Exclude<keyof LocaleText, '__typename' | 'japan'>

export const LANG_KEYS: Record<(typeof SUPPORT_LANGUAGES)[number], SERVER_SUPPORT_LANGUAGES> = {
  en: 'english',
  ko: 'korean',
} as const

export const getCurrentLocale = () => LANG_KEYS[langVar()]
